import config from "./config.json";

/** "dev" | "prod" */
const LAUNCH_MODE = "prod";

/**
 * Retrieves configuration based on the launch mode.
 * @returns {Object} A filtered configuration object.
 */
function getConfig() {
    // Determine the prefix based on the launch mode
    const prefix = LAUNCH_MODE === "prod" ? "PROD_" : "DEV_";
    config.LAUNCH_MODE = LAUNCH_MODE;

    // Filter keys that start with the specified prefix and remove the prefix
    return Object.keys(config)
        .filter(key => key.startsWith(prefix) || key === "LAUNCH_MODE") // Only include keys with the prefix
        .reduce((filtered, key) => {
            // Remove the prefix from the key
            if (key === "LAUNCH_MODE") {
                filtered[key] = config[key]; // Keep LAUNCH_MODE as is
                return filtered;
            }
            const strippedKey = key.replace(prefix, "");
            // Add the stripped key-value pair to the filtered object
            filtered[strippedKey] = config[key];
            return filtered;
        }, {});
}

// Export the value of getConfig() directly
export default getConfig();
